export default {
  name: "Résztvevő neve",
  role: "Résztvevő szerepköre",
};
